import { Box, Checkbox, CircularProgress, FormControlLabel, Unstable_Grid2 as Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { setcurrentmenu } from "../../stores/menuslice";
import { DropdownModel } from "../../data/interfaces/sharedmodels";
import commonService from "../../data/api/common.service";
import userService from "../../data/api/user.service";
import NLCList from "../../shared/nlclist";
import reportsService from "../../data/api/reports.service";
import { updateSelectedTocs } from "../../stores/reportslice";
import { Download } from "@mui/icons-material";

export default function Reports() {
    const dispatch = useAppDispatch();
    const [ticketTypes, setTicketTypes] = useState<DropdownModel[]>([]);
    const [selectedTicketTypes, setSelectedTicketTypes] = useState<DropdownModel[]>([]);
    const [tocs, setTocs] = useState<DropdownModel[]>([]);
    const [reports, setReports] = useState<DropdownModel[]>([]);
    const selectedNlcs = useAppSelector((state) => state.reportsReducer.selectedNlcs);
    const selectedTocs = useAppSelector((state) => state.reportsReducer.selectedTocs);
    const [isDownoading, setIsDownloading] = useState(false);
    const [reportId, setReportId] = useState(undefined as string | undefined);
    useEffect(() => {
        dispatch(setcurrentmenu('reports'));
        commonService.getTicketTypes().then((response) => {
            setTicketTypes(response.data);
        });

        userService.isCubicUser().then((response) => {
            if (response.data) {
                commonService.getTocs().then((response2) => {
                    setTocs(response2.data)
                })
            }
        });

    }, []);

    useEffect(() => {
        if (ticketTypes && ticketTypes.length) {
            setSelectedTicketTypes([ticketTypes[0]])
        }
    }, [ticketTypes]);

    useEffect(() => {
        if (tocs && tocs.length) {
            dispatch(updateSelectedTocs([tocs[0].Id]));
        }
    }, [tocs]);


    useEffect(() => {
        if (selectedTicketTypes && selectedTicketTypes.length && selectedTocs && selectedTicketTypes.length) {
            reportsService.getReports(selectedTocs, selectedTicketTypes.flatMap(a => Number.parseInt(a.Id)), selectedNlcs.length > 0)
                .then((response) => {
                    setReports(response.data);
                })
        }
    }, [selectedNlcs, selectedTicketTypes, selectedTocs]);
    const handleToggleTicketTypes = (checked: boolean, ticketType: DropdownModel) => {
        let tempSelectedTicketTypes = [...selectedTicketTypes];

        if (checked && tempSelectedTicketTypes.findIndex(a => a.Id == ticketType.Id) < 0)
            tempSelectedTicketTypes.push(ticketType);
        else if (!checked && tempSelectedTicketTypes.findIndex(a => a.Id == ticketType.Id) > -1)
            tempSelectedTicketTypes.splice(tempSelectedTicketTypes.findIndex(a => a.Id == ticketType.Id), 1);
        setSelectedTicketTypes(tempSelectedTicketTypes);
    }
    const handleToggleToc = (checked: boolean, toc: DropdownModel) => {
        let tempSelectedTocs = [...selectedTocs];

        if (checked && tempSelectedTocs.findIndex(a => a.toString() == toc.Id) < 0)
            tempSelectedTocs.push(Number.parseInt(toc.Id));
        else if (!checked && tempSelectedTocs.findIndex(a => a.toString() == toc.Id) > -1)
            tempSelectedTocs.splice(tempSelectedTocs.findIndex(a => a.toString() == toc.Id), 1);
        dispatch(updateSelectedTocs(tempSelectedTocs));
    }

    const handleDownload = (report: DropdownModel) => {
        setReportId(report.Id);
        setIsDownloading(true);
        var nlcs=report.Description.includes('Global')?[1]: selectedNlcs.flatMap(a => a.Id);
        for (let index = 0; index < (nlcs.length)/10; index++) {
            var nlcstoSend=nlcs.slice(index*10, (index*10) + 10);
            reportsService.getReportDownload(report.Id, selectedTocs, nlcstoSend).then(
                (response) => {
                    if(index>=((nlcs.length)/10)-1)setIsDownloading(false);
                    if (!response)
                        return;
                    let headerLine = response.headers['content-disposition'];
                    let startFileNameIndex = headerLine.indexOf('"') + 1
                    let endFileNameIndex = headerLine.lastIndexOf('"');
                    let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                    if (selectedTocs.length <= 1 && selectedNlcs.length <= 1) {
                        const blob = new Blob([response.data]);
    
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
    
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
    
                    } else {
                        const blob = new Blob([response.data], { type: 'application/zip' });
    
    
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
    
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
    
                    }
                }
            )
            
        }
        
    }
    return (
        <Grid container spacing={2} sx={{ m: 1 }}>
            <Grid xs={3}>
                <Box component={Paper} padding={1}>
                    <Typography variant="h6">Ticket Types</Typography>
                    <List disablePadding={true}>
                        {
                            ticketTypes.map(function (ticketType) {
                                return (
                                    <ListItemButton key={ticketType.Id}>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                onChange={(e) => handleToggleTicketTypes(e.target.checked, ticketType)}
                                                checked={selectedTicketTypes.findIndex(b => b.Id == ticketType.Id) > -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': ticketType.Description }} />
                                        </ListItemIcon>
                                        <ListItemText primary={ticketType.Description} />
                                    </ListItemButton>)
                            })
                        }
                    </List>
                </Box>
                {tocs.length ? <Box component={Paper} padding={1} marginTop={2}>
                    <Typography variant="h6">TOCs</Typography>
                    <List disablePadding={true}>
                        {
                            tocs.map(function (toc) {
                                return (
                                    <ListItemButton key={toc.Id}>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                onChange={(e) => handleToggleToc(e.target.checked, toc)}
                                                checked={selectedTocs.findIndex(b => b.toString() == toc.Id) > -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': toc.Description }} />
                                        </ListItemIcon>
                                        <ListItemText primary={toc.Description} />
                                    </ListItemButton>)
                            })
                        }
                    </List>
                </Box> : null}
            </Grid>
            <Grid xs={3}>

                <NLCList parent="reports_output" disabled={false} />
            </Grid>
            <Grid xs={6}>
                <Box component={Paper} padding={1}>
                    <Typography variant="h6">Reports</Typography>
                    <List disablePadding={false} component={Paper}>
                        {
                            reports.map(function (report) {
                                return (
                                    <ListItem key={report.Id} >
                                        <ListItemText primary={report.Description} />
                                        <ListItemIcon sx={{ cursor: 'pointer' }} onClick={() => { handleDownload(report) }}>
                                            {isDownoading && report.Id == reportId ? <CircularProgress size={30} color="primary" /> : <Download color="primary" />}
                                        </ListItemIcon>
                                    </ListItem>)
                            })
                        }
                    </List>
                </Box>
            </Grid>
        </Grid>

    )
}